import { render, staticRenderFns } from "./LayoutVertical.vue?vue&type=template&id=33231bde&scoped=true&"
import script from "./LayoutVertical.vue?vue&type=script&lang=js&"
export * from "./LayoutVertical.vue?vue&type=script&lang=js&"
import style0 from "./LayoutVertical.vue?vue&type=style&index=0&id=33231bde&scoped=true&lang=css&"
import style1 from "./LayoutVertical.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33231bde",
  null
  
)

export default component.exports